






























import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";

export default Vue.extend({
  data() {
    return {
      valid: false,
      loading: false,
      error: "",
      ruleRequired: (value) => !!value || this.$t("REQUIRED"),
      data: {},
    };
  },
  methods: {
    async submit() {
      this.error = "";
      this.loading = true;
      try {
        const ok = await coreApiClient.callRaw("auth", "updatePassword", undefined, {
          oldPassword: this.data.oldPassword,
          newPassword: this.data.newPassword,
        });
        if (ok) {
          alert("Đổi mật khẩu thành công");
          location.reload();
        }
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
      }
    },
  },
});
